(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["avis-clients"]) return;
  try {
    
  (function () {
    // Défilement continu et interruptible : appui = arrêt immédiat, glisser = suivi 1:1, lancer = élan qui revient à la vitesse normale.
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const FLING = -1 / Math.log(0.998); // ≈ 500 ms : la décélération du défilement iOS
    const RESUME = 450;
    const MAX_SPEED = 6; // px/ms
    const MOVE_SLOP = 6;
    const HOLD_MS = 350;
    const SPRING = (2 * Math.PI) / 450; // réponse 0,45 s, amortissement critique
    const ARROW_CARDS = 3;

    function initRow(vp) {
      if (vp.dataset.ykAvLive) return;
      vp.dataset.ykAvLive = '1';
      const track = vp.querySelector('.yk-av__track');
      const cs = getComputedStyle(track);
      const seconds = parseFloat(cs.animationDuration) || 120;
      const sign = cs.animationDirection === 'reverse' ? 1 : -1;
      // On repart de la position affichée par l'animation CSS : aucun saut à la reprise.
      let x = cs.transform && cs.transform !== 'none' ? new DOMMatrixReadOnly(cs.transform).m41 : 0;
      let half = 0, auto = 0, v = 0, last = 0, raf = 0;
      let visible = false, hover = false, focus = false, down = false;
      let id = null, type = '', startPx = 0, startX = 0, startAt = 0, moved = false, swallow = false, samples = [];
      let shift = 0, shiftV = 0; // déplacement des flèches : ressort sans rebond, cumulable et interruptible

      const measure = () => {
        const w = track.getBoundingClientRect().width / 2;
        if (!w) return;
        if (half) x *= w / half;
        half = w;
        auto = (sign * half) / (seconds * 1000);
        if (!down && !v) v = auto;
      };
      const paint = () => {
        x = half ? ((x % half) - half) % half : 0;
        track.style.transform = 'translate3d(' + x + 'px, 0, 0)';
      };
      const tick = (now) => {
        const dt = Math.min(now - last, 64);
        last = now;
        if (!down) {
          const target = hover || focus ? 0 : auto;
          const tau = Math.abs(v) > Math.abs(auto) * 1.5 ? FLING : RESUME;
          v = target + (v - target) * Math.exp(-dt / tau);
          x += v * dt;
          for (let left = dt; left > 0 && (Math.abs(shift) > 0.3 || Math.abs(shiftV) > 0.01); left -= 8) {
            const h = Math.min(left, 8);
            shiftV += (SPRING * SPRING * shift - 2 * SPRING * shiftV) * h;
            const d = shiftV * h;
            x += d;
            shift -= d;
          }
          paint();
        }
        raf = requestAnimationFrame(tick);
      };
      const start = () => { if (!raf) { last = performance.now(); raf = requestAnimationFrame(tick); } };
      const stop = () => { cancelAnimationFrame(raf); raf = 0; };

      vp.addEventListener('pointerdown', (e) => {
        if (!e.isPrimary || e.button) return;
        down = true; id = e.pointerId; type = e.pointerType; moved = false; swallow = false;
        shift = 0; shiftV = 0;
        startPx = e.clientX; startX = x; startAt = performance.now();
        v = 0;
        samples = [{ t: e.timeStamp, x: e.clientX }];
        vp.classList.add('is-held');
      });
      vp.addEventListener('pointermove', (e) => {
        if (!down || e.pointerId !== id) return;
        const dx = e.clientX - startPx;
        if (!moved && Math.abs(dx) > MOVE_SLOP) {
          moved = true;
          // Capture tardive : sinon le clic sur un lien de carte serait détourné vers la rangée.
          if (type === 'mouse') vp.setPointerCapture(id);
        }
        x = startX + dx;
        paint();
        samples.push({ t: e.timeStamp, x: e.clientX });
        while (samples.length > 2 && e.timeStamp - samples[0].t > 100) samples.shift();
      });
      const release = (e) => {
        if (!down || e.pointerId !== id) return;
        down = false;
        vp.classList.remove('is-held');
        const a = samples[0], b = samples[samples.length - 1];
        const fresh = e.timeStamp - b.t < 80 && b.t > a.t;
        const speed = e.type === 'pointerup' && moved && fresh ? (b.x - a.x) / (b.t - a.t) : 0;
        v = Math.max(-MAX_SPEED, Math.min(MAX_SPEED, speed));
        // Un appui long pour lire ne doit pas ouvrir le produit au moment de relâcher.
        swallow = moved || (type !== 'mouse' && performance.now() - startAt > HOLD_MS);
      };
      vp.addEventListener('pointerup', release);
      vp.addEventListener('pointercancel', release);
      vp.addEventListener('click', (e) => { if (swallow) { e.preventDefault(); e.stopPropagation(); swallow = false; } }, true);
      vp.addEventListener('dragstart', (e) => e.preventDefault());
      vp.addEventListener('contextmenu', (e) => { if (down && type !== 'mouse') e.preventDefault(); });

      // Ordinateur : la souris sur la rangée met en pause, le trackpad la fait défiler.
      const zone = vp.closest('.yk-av__stage') || vp; // flèches comprises
      if (matchMedia('(hover: hover) and (pointer: fine)').matches) {
        zone.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') hover = true; });
        zone.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') hover = false; });
      }
      vp.addEventListener('wheel', (e) => {
        if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
        e.preventDefault();
        x -= e.deltaX;
        v = 0;
        paint();
      }, { passive: false });
      zone.addEventListener('focusin', (e) => { focus = e.target.matches(':focus-visible'); });
      zone.addEventListener('focusout', () => { focus = false; });
      // Le navigateur fait défiler la zone masquée pour montrer un lien au clavier : on le reporte sur la piste.
      vp.addEventListener('scroll', () => { x -= vp.scrollLeft; vp.scrollLeft = 0; paint(); });

      measure();
      paint();
      vp.classList.add('is-live');
      new ResizeObserver(measure).observe(track);
      new IntersectionObserver((entries) => {
        visible = entries[entries.length - 1].isIntersecting;
        if (visible) start(); else stop();
      }).observe(vp);

      return (dir) => {
        const card = track.querySelector('.yk-av__card');
        const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(card).marginRight);
        shift -= dir * step * ARROW_CARDS;
        start();
      };
    }

    function initSection(root) {
      const rows = [...root.querySelectorAll('.yk-av__viewport')].map(initRow).filter(Boolean);
      if (!rows.length) return;
      root.querySelectorAll('[data-yk-av-arrow]').forEach((btn) => {
        btn.hidden = false;
        btn.addEventListener('click', () => rows.forEach((go) => go(Number(btn.dataset.ykAvArrow))));
      });
    }

    const init = () => document.querySelectorAll('[data-yk-av]').forEach(initSection);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    // Les boutons de paiement express doivent être réinitialisés après chaque mise à jour AJAX du tiroir.
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    const seen = new WeakSet();
    const init = () => {
      const box = drawer.querySelector('.cart-drawer__dynamic');
      if (!box || seen.has(box)) return;
      seen.add(box);
      if (window.Shopify && Shopify.StorefrontExpressButtons && Shopify.StorefrontExpressButtons.initialize) Shopify.StorefrontExpressButtons.initialize();
    };
    const first = drawer.querySelector('.cart-drawer__dynamic');
    if (first) seen.add(first); // déjà initialisé par Shopify au chargement

    // Dates du bandeau de livraison (heure de Paris), remplies aussi après chaque mise à jour AJAX.
    const fillDates = () => {
      const band = drawer.querySelector('[data-cart-band]');
      if (!band) return;
      const [y, m, d] = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Paris' }).format(new Date()).split('-').map(Number);
      const short = new Intl.DateTimeFormat('fr-FR', { timeZone: 'UTC', weekday: 'short', day: 'numeric', month: 'short' });
      band.querySelectorAll('[data-cart-band-date]').forEach((el) => {
        const days = Number(band.dataset[el.dataset.cartBandDate] || 0);
        const text = short.format(new Date(Date.UTC(y, m - 1, d + days))).replace(/\.$/, '');
        if (el.textContent !== text) el.textContent = text;
      });
    };

    // Suggestions repliables : l'état ouvert survit à la mise à jour AJAX du tiroir (ajout, retrait).
    let upsellOpen = null;
    const applyUpsell = (animate) => {
      const box = drawer.querySelector('[data-cart-upsell]');
      if (!box) return;
      if (upsellOpen === null) upsellOpen = box.classList.contains('is-open');
      box.classList.toggle('no-anim', !animate);
      box.classList.toggle('is-open', upsellOpen);
      box.querySelector('[data-cart-upsell-toggle]').setAttribute('aria-expanded', String(upsellOpen));
      if (!animate) requestAnimationFrame(() => box.classList.remove('no-anim'));
    };
    drawer.addEventListener('click', (e) => {
      if (!e.target.closest('[data-cart-upsell-toggle]')) return;
      upsellOpen = !drawer.querySelector('[data-cart-upsell]').classList.contains('is-open');
      applyUpsell(true);
      if (!upsellOpen) return;
      const panel = drawer.querySelector('.cart-upsell-panel');
      panel.addEventListener('transitionend', () => panel.scrollIntoView({ block: 'nearest', behavior: 'smooth' }), { once: true });
    });

    const refresh = () => { init(); fillDates(); applyUpsell(false); };
    fillDates();
    applyUpsell(false);
    new MutationObserver(refresh).observe(drawer, { childList: true, subtree: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
  (function () {
    if (customElements.get('newsletter-popup')) return;
    const KEY = 'yk-nlp-until';
    const store = {
      get() { try { return parseInt(localStorage.getItem(KEY) || '0', 10); } catch (e) { return 0; } },
      set(days) { try { localStorage.setItem(KEY, String(Date.now() + days * 864e5)); } catch (e) {} }
    };
    class NewsletterPopup extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('.nlp__dialog');
        this.form = this.querySelector('form.nlp__form');
        this.querySelectorAll('[data-nlp-close]').forEach((b) => b.addEventListener('click', () => this.close()));
        this.initSwipe();
        this.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.close(); if (e.key === 'Tab') this.trap(e); });
        const copy = this.querySelector('[data-nlp-copy]');
        if (copy) copy.addEventListener('click', () => {
          const label = copy.textContent;
          const done = () => { copy.textContent = 'Copié'; setTimeout(() => { copy.textContent = label; }, 1500); };
          if (navigator.clipboard) navigator.clipboard.writeText(copy.dataset.nlpCopy).then(done, done); else done();
        });
        if (this.form) this.form.addEventListener('submit', (e) => this.submit(e));
        const preview = new URLSearchParams(location.search).get('popup');
        if (preview) {
          if (['classique', 'editorial'].includes(preview)) {
            this.classList.remove('nlp--classique', 'nlp--editorial');
            this.classList.add('nlp--' + preview);
          }
          const align = new URLSearchParams(location.search).get('align');
          if (align) this.classList.toggle('nlp--left', align === 'left');
          return this.open();
        }
        if (document.documentElement.dataset.nlpDone) { store.set(365); return this.open(); }
        if (this.hasAttribute('data-force')) return this.open();
        if (window.Shopify && Shopify.designMode) {
          document.addEventListener('shopify:section:select', (e) => { if (e.target.contains(this)) this.open(); });
          document.addEventListener('shopify:section:deselect', (e) => { if (e.target.contains(this)) this.close(true); });
          return;
        }
        if (store.get() > Date.now()) return;
        if (this.dataset.mobile !== 'true' && window.matchMedia('(max-width: 749px)').matches) return;
        // Temps passé sur le site (cumulé de page en page pendant la visite) ou défilement de la page : le premier atteint ouvre.
        const delay = Math.max(2, parseInt(this.dataset.delay || '60', 10)) * 1000;
        let start = Date.now();
        try {
          const saved = parseInt(sessionStorage.getItem('yk-nlp-start') || '0', 10);
          if (saved) start = saved; else sessionStorage.setItem('yk-nlp-start', String(start));
        } catch (e) {}
        this.timer = setTimeout(() => this.openWhenFree(), Math.max(3000, start + delay - Date.now()));
        const pct = parseInt(this.dataset.scroll || '0', 10);
        if (pct > 0) {
          this.onScroll = () => {
            const max = document.documentElement.scrollHeight - window.innerHeight;
            if (max > 0 && window.scrollY / max >= pct / 100) this.openWhenFree();
          };
          window.addEventListener('scroll', this.onScroll, { passive: true });
        }
        if (this.dataset.exit === 'true') {
          this.exit = (e) => { if (e.clientY <= 0 && !e.relatedTarget) this.openWhenFree(); };
          document.addEventListener('mouseout', this.exit);
        }
      }
      // Jamais par-dessus le bandeau de cookies, un tiroir (panier, menu) ou une autre fenêtre : on patiente.
      busy() {
        const banner = document.getElementById('shopify-pc__banner');
        if (banner) {
          // Bandeau en position fixe : offsetParent vaut toujours null, on mesure sa boîte.
          const r = banner.getBoundingClientRect();
          const cs = getComputedStyle(banner);
          if (r.width > 0 && r.height > 0 && cs.display !== 'none' && cs.visibility !== 'hidden') return true;
        }
        return !!document.querySelector('.drawer.is-open, .modal.is-open') || document.body.classList.contains('scroll-locked');
      }
      openWhenFree() {
        clearTimeout(this.timer);
        if (this.exit) document.removeEventListener('mouseout', this.exit);
        if (this.onScroll) { window.removeEventListener('scroll', this.onScroll); this.onScroll = null; }
        if (this.busy()) { this.timer = setTimeout(() => this.openWhenFree(), 2500); return; }
        this.open();
      }
      async open() {
        if (this.isOpen) return;
        this.isOpen = true;
        clearTimeout(this.timer);
        if (this.exit) document.removeEventListener('mouseout', this.exit);
        this.lastFocus = document.activeElement;
        // L'image arrive avec la fenêtre, pas après (délai maximal 0,8 s).
        const img = this.querySelector('.nlp__media img');
        if (img && !img.complete) {
          img.loading = 'eager';
          await Promise.race([img.decode().catch(() => {}), new Promise((r) => setTimeout(r, 800))]);
        }
        this.hidden = false;
        document.body.classList.add('scroll-locked');
        requestAnimationFrame(() => requestAnimationFrame(() => this.classList.add('is-open')));
        // Écran tactile : pas de focus du champ (clavier et zoom intempestifs).
        const touch = window.matchMedia('(pointer: coarse)').matches;
        setTimeout(() => { const f = this.querySelector('.nlp__input'); (!touch && f && f.offsetParent ? f : this.dialog).focus({ preventScroll: true }); }, 60);
      }
      close(silent) {
        if (!this.isOpen) return;
        this.isOpen = false;
        this.classList.remove('is-open');
        if (!silent) store.set(parseInt(this.dataset.days || '14', 10));
        if (!document.querySelector('.drawer.is-open, .modal.is-open')) document.body.classList.remove('scroll-locked');
        setTimeout(() => { this.hidden = true; this.dialog.style.transform = ''; this.dialog.style.transition = ''; const o = this.querySelector('.nlp__overlay'); if (o) o.style.opacity = ''; }, 400);
        if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus({ preventScroll: true });
      }
      // Feuille mobile : on la tire vers le bas pour la fermer (suivi 1:1, élan projeté, résistance vers le haut).
      initSwipe() {
        const zone = this.querySelector('.nlp__media');
        const overlay = this.querySelector('.nlp__overlay');
        if (!zone) return;
        const mobile = () => window.matchMedia('(max-width: 749px)').matches;
        const presentY = () => { const m = getComputedStyle(this.dialog).transform; return m && m !== 'none' ? new DOMMatrixReadOnly(m).m42 : 0; };
        const render = (y) => {
          this.dialog.style.transform = `translateY(${y}px)`;
          if (overlay) overlay.style.opacity = String(Math.max(0, 1 - y / this.dialog.offsetHeight));
        };
        let g = null;
        zone.addEventListener('pointerdown', (e) => {
          if (!this.isOpen || !mobile() || e.button !== 0) return;
          const base = presentY(); // rattrape la feuille là où elle est, même en mouvement
          this.classList.add('is-dragging');
          render(base);
          g = { id: e.pointerId, y0: e.clientY, base, samples: [{ y: e.clientY, t: e.timeStamp }] };
          try { zone.setPointerCapture(e.pointerId); } catch (x) {}
        });
        zone.addEventListener('pointermove', (e) => {
          if (!g || e.pointerId !== g.id) return;
          let y = g.base + (e.clientY - g.y0);
          if (y < 0) y = (y * 120 * 0.55) / (120 + 0.55 * Math.abs(y)); // résistance élastique vers le haut
          g.samples.push({ y: e.clientY, t: e.timeStamp });
          if (g.samples.length > 6) g.samples.shift();
          render(y);
        });
        const release = (e) => {
          if (!g || e.pointerId !== g.id) return;
          const s = g.samples.filter((p) => e.timeStamp - p.t < 100);
          const v = s.length > 1 ? ((s[s.length - 1].y - s[0].y) / Math.max(1, s[s.length - 1].t - s[0].t)) * 1000 : 0;
          const y = presentY();
          const h = this.dialog.offsetHeight;
          const projected = y + (v / 1000) * 0.998 / (1 - 0.998);
          g = null;
          this.classList.remove('is-dragging');
          if (projected > h / 3) {
            render(h);
            this.close();
          } else {
            this.dialog.style.transform = '';
            if (overlay) overlay.style.opacity = '';
          }
        };
        zone.addEventListener('pointerup', release);
        zone.addEventListener('pointercancel', release);
      }
      trap(e) {
        const els = [...this.dialog.querySelectorAll('a[href], button, input:not([type="hidden"])')].filter((el) => el.offsetParent !== null);
        if (!els.length) return;
        const first = els[0], last = els[els.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
      async submit(e) {
        e.preventDefault();
        const err = this.querySelector('[data-nlp-error]');
        const btn = this.form.querySelector('button[type="submit"]');
        const email = this.form.querySelector('input[type="email"]');
        err.textContent = '';
        if (!email.value || !email.checkValidity()) { err.textContent = 'Saisissez une adresse e-mail valide.'; email.focus(); return; }
        btn.disabled = true;
        if (this.dataset.klaviyoList) return this.subscribeKlaviyo(email.value.trim(), err, btn);
        try {
          const res = await fetch(this.form.action, { method: 'POST', body: new FormData(this.form), headers: { Accept: 'text/html' } });
          if (/challenge/.test(res.url)) { this.form.submit(); return; }
          const html = await res.text();
          if (/customer_posted=true/.test(res.url) || /posted_successfully|form-message--success/.test(html)) return this.success();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const msg = doc.querySelector('#NewsletterPopup .nlp__error, #NewsletterPopup .errors');
          err.textContent = (msg && msg.textContent.trim()) || 'Inscription impossible pour le moment. Réessayez dans un instant.';
        } catch (x) {
          this.form.submit();
        } finally { btn.disabled = false; }
      }
      async subscribeKlaviyo(email, err, btn) {
        // Inscription directe à la liste Klaviyo (API client publique) ; le flow Klaviyo envoie le code unique.
        const body = { data: { type: 'subscription', attributes: {
          custom_source: 'Pop-up première commande',
          profile: { data: { type: 'profile', attributes: { email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } }
        }, relationships: { list: { data: { type: 'list', id: this.dataset.klaviyoList } } } } };
        try {
          const res = await fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(this.dataset.klaviyoKey), {
            method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', revision: '2025-01-15' }, body: JSON.stringify(body)
          });
          if (res.ok) {
            if (window.klaviyo && window.klaviyo.identify) { try { window.klaviyo.identify({ email }); } catch (x) {} }
            return this.success();
          }
          err.textContent = 'Inscription impossible pour le moment. Réessayez dans un instant.';
        } catch (x) {
          err.textContent = 'Connexion impossible. Vérifiez votre réseau et réessayez.';
        } finally { btn.disabled = false; }
      }
      success() {
        this.querySelector('[data-nlp-fields]').hidden = true;
        this.querySelector('[data-nlp-success]').hidden = false;
        const d = this.querySelector('[data-nlp-decline]'); if (d) d.hidden = true;
        store.set(365);
        const copy = this.querySelector('[data-nlp-copy]');
        (copy || this.querySelector('[data-nlp-success]')).focus({ preventScroll: true });
      }
    }
    customElements.define('newsletter-popup', NewsletterPopup);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trip-checklist"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('tabs:change', (e) => {
    const root = e.target.closest('.checklist');
    if (!root) return;
    const tab = e.target.querySelectorAll('[role="tab"]')[e.detail.index];
    if (!tab) return;
    root.querySelectorAll('[data-trip-photo]').forEach((ph) => { ph.hidden = ph.dataset.tripPhoto !== tab.dataset.blockId; });
    // Le nouveau panneau glisse depuis le côté de l'onglet choisi (continuité spatiale), puis se pose.
    const prev = root._ckIndex ?? 0;
    root._ckIndex = e.detail.index;
    const panel = root.querySelector('#Panel-' + tab.dataset.blockId);
    if (panel && prev !== e.detail.index) {
      panel.style.setProperty('--ck-dir', e.detail.index > prev ? 1 : -1);
      panel.classList.remove('is-entering');
      void panel.offsetWidth;
      panel.classList.add('is-entering');
      panel.addEventListener('animationend', () => panel.classList.remove('is-entering'), { once: true });
    }
    // Sur mobile, l'onglet choisi vient se placer dans la rangée de pastilles.
    if (tab.parentElement.scrollWidth > tab.parentElement.clientWidth) tab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
   }, true);

  } catch(e) { console.error(e); }
})();
})();
